<template>
  <div class="mb-3 rounded-5" :class="[`${group.color}-feed-background`]">
    <div
      class="card rounded-5 card-body bg-light shadow-sm text-dark p-4"
      :class="[`${group.color}-feed-inner`]"
    >
      <div class="row align-items-center">
        <div class="col-4 text-start d-flex align-items-center">
          <div class="me-2 d-none d-md-block">
            <UserProfile
              :fullname="fullname"
              :userImage="userImage"
              :size="size"
              fontSize="1"
            />
          </div>
          <div class="fs-4 fw-bold my-auto">
            {{ shorten ? shortenName(fullname) : fullname }}
          </div>
        </div>
        <div class="col">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserProfile from "@/components/activity/UserProfile.vue";
import { mapGetters } from "vuex";
import { shortenName } from "@/helpers/common.js";

// Data
export default {
  name: "UserCard",
  components: { UserProfile },
  props: {
    userId: {
      type: String,
      required: true
    },
    fullname: {
      type: String,
      required: true
    },
    userImage: {
      type: String,
      required: true
    },
    shorten: {
      type: Boolean,
      default: true
    },
    size: {
      type: [Number, String],
      default: 65
    }
  },
  computed: {
    ...mapGetters("groups", ["getGroupByUserId"]),
    group() {
      return this.getGroupByUserId(this.userId);
    }
  },
  methods: {
    shortenName
  }
};
</script>
